import * as types from "../actions/actionTypes";

// state = [] : Start out with no accounts
export default function userEducation(state = [], action) {
  switch (action.type) {
    case types.GET_USER_EDUCATION:
      return action.user_education;

    default:
      return state;
  }
}
